/**
 * This file should contain all reusable sizes, spacings, gutters and etc.
 */
export default {
  minWidth: 1280,
  breakpointSmall: 1440,
  appBarHeight: 60,
  gutter: 30,
  gridColumnsCount: 12
};